<template>
  <div class="tree-skeleton">
    <div
      v-for="(node, index) in nodes"
      :key="index"
      class="tree-skeleton__card"
      :style="{ marginLeft: `${node.level * 20}px` }"
    >
      <div class="tree-skeleton__section tree-skeleton__section--left">
        <div class="tree-skeleton__bar short"></div>
        <div
          v-if="node.lines > 1"
          v-for="n in node.lines - 1"
          :key="n"
          class="tree-skeleton__bar secondary"
        ></div>
      </div>
      <div
        class="tree-skeleton__section tree-skeleton__section--right"
        v-if="node.level < 2"
      >
        <div class="tree-skeleton__bar secondary"></div>
        <div
          v-if="node.linesRight > 1"
          v-for="n in node.linesRight - 1"
          :key="n"
          class="tree-skeleton__bar short"
        ></div>
      </div>
      <div
        class="tree-skeleton__section tree-skeleton__section--right"
        v-else
      >
        <div class="tree-skeleton__bar chip" style="width: 40%"></div>
        <div
          v-if="node.linesRight > 1"
          v-for="n in node.linesRight - 1"
          :key="n"
          class="tree-skeleton__bar chip"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface TreeNode {
  level: number
  lines?: number // para simular título + subtítulo/description
  linesRight?: number // simula opciones
}

// Estructura: 1 padre → 2 hijos → 3 nietos en hijo 1 y 1 en hijo 2
const nodes: TreeNode[] = [
  { level: 0, lines: 2, linesRight: 2 },  // Padre
  { level: 1, lines: 2, linesRight: 1 },  // Hijo 1
  { level: 2, lines: 2, linesRight: 2 },  // Nieto 1
  { level: 2, lines: 2, linesRight: 2 },  // Nieto 2
  { level: 2, lines: 2, linesRight: 2 },  // Nieto 3
  { level: 1, lines: 2, linesRight: 1 },  // Hijo 2
  { level: 2, lines: 2, linesRight: 2 },  // Nieto 4
]
</script>

<style scoped lang="sass">
.tree-skeleton
  display: flex
  flex-direction: column
  gap: 12px
  margin-top: 10px

  &__card
    width: 500px
    display: flex
    justify-content: space-between
    align-items: start
    background: #fff
    border: 1px solid #f0f0f0
    border-radius: 8px
    padding: 10px 12px
    box-shadow: 0 1px 2px rgba(0,0,0,0.04)
    min-height: 24px
    gap: 10px
    position: relative
    overflow: visible

  &__section
    max-width: 50%
    display: flex
    flex-direction: column
    gap: 8px
    flex: 1

    &--right
      align-items: end

  &__bar
    height: 14px
    border-radius: 10px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)
    background-size: 400% 100%
    animation: skeleton-loading 1.4s ease infinite

    &.short
      width: 60%

    &.secondary
      width: 90%

    &.chip
      width: 50%

@keyframes skeleton-loading
  0%
    background-position: 100% 50%
  100%
    background-position: 0 50%
</style>
